import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Button,    
} from "reactstrap";
// core components
import {validEmailRegex} from '../../settings/shared/constants'
import { toast } from 'react-toastify';
import LoginService from '../../services/api/Login'
import CircleLoader from "react-spinners/CircleLoader";
import LoadingOverlay from 'react-loading-overlay';
import Background from 'assets/img/1.jpg';
import Background2 from 'assets/img/2.jpg';
import Background3 from 'assets/img/3.jpg';
import Background4 from 'assets/img/4.jpg';
import Background5 from 'assets/img/5.jpg';
 import Background6 from 'assets/img/bg14.jpg';
 import "../../assets/css/custom.css";


const styles = {
  errorBox:{
    textAlign:"center",
    marginBottom:20
  },
  error:{
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 100px 6px 100px",
    borderRadius:6
  },
  passwordHint:{
    color:"white",
    fontSize:13
  }
}
class ForgotPassword extends React.Component {

  constructor(props) {
    super(props)     
    this.state = { 
    errorSubmitted:false,
    email:'',
    errorMessage:'',
    images: [
      Background,
      Background2,
      Background3,
      Background4,
      Background5,
      Background6,
    ],
    }
}

 componentDidMount() {
    document.body.classList.add("login-page");
    document.body.style.backgroundImage = `url(${this.state.selectedImage})`;
    var background = this.state.images[Math.floor(Math.random() * this.state.images.length)];
    this.state.selectedImage = background;
   
  document.body.classList.add("bgdefault");
  document.body.style.backgroundImage = `url(${this.state.selectedImage})`;
  document.body.style.backgroundPosition = 'center';
  document.body.style.backgroundSize = 'cover';
  document.body.style.backgroundRepeat = 'no-repeat';
  }

  setErrorMessage(message){
     if(message===""){
       this.setState({
         errorMessage:message,
         errorSubmitted:false
       })
     }else{
    document.getElementById('errorDiv').scrollIntoView()
     this.setState({
       errorMessage:message,
       errorSubmitted:true
     });
     }
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
      this.setState({ [name]: value});
  }

  // Submit user Data
  SubmitPasswordChange = (event) => {
    event.preventDefault();
      if(this.state.email==="" || this.state.email===undefined){
         this.setErrorMessage("Please Enter Email");
      }
      else if(!validEmailRegex.test(this.state.email)){
            this.setErrorMessage("Email is not valid!");
      }
       else{
         this.setErrorMessage("");
          if(!this.state.errorSubmitted) { 
          let email_parse = this.state.email;
          email_parse = email_parse.replace(/\+/gi, '%2B');   // // Encode value if "+" to "%2B"
              let post ={
                email:email_parse
              }
                LoginService.forgotPassword(post)
                .then((response) => {
                    if (response.status === 'SUCCESS') {
                    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Reset Link sent Successfully!</b></i>); 
                    this.props.history.push('/auth/login');
                    this.clearformData();   // Reset Form data    
                    } else {
                      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
                      this.clearformData();   // Reset Form data    
                    }
                });
                  }else{
                    console.error('Invalid Form')
                  }
      }  
  }

  // Reset form data
  clearformData(){
    this.setState({
      email:'',
    })
  }


  render() { 
    return (
      <LoadingOverlay
      active={this.state.loading}
      spinner={<CircleLoader
        size={35}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
      <>
      <div className="content">
          <div className="login-page">
            <Container>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
           
            
              <Col xs={12} md={8} lg={5} className="ml-auto mr-auto">
                {/* <Form> */}
                  <Card className="card-login card-plain">
                    <CardHeader>
                        <CardTitle>Forgot Password?</CardTitle>
                     </CardHeader>
                     <CardBody>
                     <div className="carcontent">
                {this.state.errorSubmitted &&
                    <div style={styles.errorBox}>
                    <span style={styles.error}>{this.state.errorMessage}</span>
                    </div>
                    }
                  <Form onSubmit={this.SubmitPasswordChange} noValidate>
                        <Row>
                                <Col lg="12">
                                
                                <FormGroup>
                                        <label
                                        className="form-control-label"
                                        htmlFor="input-email"
                                        style={{color:'white'}}
                                        >
                                        Email
                                        </label>
                                        <Input
                                    className="form-control"
                                    placeholder="Email"
                                    name="email"
                                    value={this.state.email}
                                    type="text"
                                    onChange={this.handleChange}/>
                                    </FormGroup>
                <span style={styles.passwordHint}><b>Note: </b>The reset link send to your registerd email. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                                </Col>
                      </Row>
                      <div className="btns-mr-5 text-center" >
                    
                    <Button color="google" href="/auth/login-page">
                      Cancel
                   </Button> &nbsp;  &nbsp;
                   
                   <Button color="google" type="submit">
                    Submit
                     </Button>
                  
                 </div>
                 </Form>
</div>
                    </CardBody>
                   
                   
                  </Card>
                {/* </Form> */}
              </Col>
            </Container>
          </div>
        </div>
      
        <div
          className="full-page-background bgdefault"
          // style={{ backgroundImage: "url(" + bgImage + ")" }}
        />
      </>
      </LoadingOverlay>
    );
  }
}

export default ForgotPassword;
